<template>
  <div id="pageRoot">

    <img
    style="width: 150px; top: 50px; left: 70px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p25/rana.svg"
    />

    <label
      class="checkMarkContainer-a"
      style="left: 294px; top: 102px; position: absolute"
      >Una Sílaba
      <input type="checkbox"
        ref="a1" 
        v-on:change="saveOption('radios', 'a1')" 
        :onload="loadOption('radios', 'a1')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 102px; position: absolute"
      >Dos Sílabas
      <input type="checkbox"
        ref="a2" 
        v-on:change="saveOption('radios', 'a2')" 
        :onload="loadOption('radios', 'a2')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 421px; top: 102px; position: absolute"
      >Tres Sílabas
      <input type="checkbox"
        ref="a3" 
        v-on:change="saveOption('radios', 'a3')" 
        :onload="loadOption('radios', 'a3')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 102px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="a4" 
        v-on:change="saveOption('radios', 'a4')" 
        :onload="loadOption('radios', 'a4')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 102px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox"
        ref="a5" 
        v-on:change="saveOption('radios', 'a5')" 
        :onload="loadOption('radios', 'a5')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 102px; position: absolute"
      >Seis Sílabas
      <input type="checkbox"
        ref="a6" 
        v-on:change="saveOption('radios', 'a6')" 
        :onload="loadOption('radios', 'a6')"
        />
      <span class="checkmark-a"></span>
    </label>

    <div style="width: 230px; height: 200px; top: 45px; left: 730px; position: absolute;">
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        class="centerH"
        style="position: absolute;
        width: 160px;
        height: 50px;
        top: 50px;
        z-index: 2"
      />
      <img
      style="width: 100%; z-index: -1"
      class="pageElement"
      src="/pages/img/general/pinnedTag.svg"
      />
    </div>

    <img
    style="width: 90%; top: 240px; left: 40px"
    class="pageElement"
    src="/pages/img/general/lineDivider.svg"
    />

    <img
    style="width: 150px; top: 280px; left: 70px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p25/pajaro.svg"
    />

    <label
      class="checkMarkContainer-a"
      style="left: 294px; top: 342px; position: absolute"
      >Una Sílaba
      <input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 342px; position: absolute"
      >Dos Sílabas
      <input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 421px; top: 342px; position: absolute"
      >Tres Sílabas
      <input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 342px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 342px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 342px; position: absolute"
      >Seis Sílabas
      <input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
      <span class="checkmark-a"></span>
    </label>

    <div style="width: 230px; height: 200px; top: 285px; left: 730px; position: absolute;">
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        class="centerH"
        style="position: absolute;
        width: 160px;
        height: 50px;
        top: 50px;
        z-index: 2"
      />
      <img
      style="width: 100%; z-index: -1"
      class="pageElement"
      src="/pages/img/general/pinnedTag.svg"
      />
    </div>

    <img
    style="width: 90%; top: 480px; left: 40px"
    class="pageElement"
    src="/pages/img/general/lineDivider.svg"
    />

    <img
    style="width: 200px; top: 520px; left: 60px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p25/guitarrero.svg"
    />

    <label
      class="checkMarkContainer-a"
      style="left: 294px; top: 593px; position: absolute"
      >Una Sílaba
      <input type="checkbox"
        ref="c1" 
        v-on:change="saveOption('radios', 'c1')" 
        :onload="loadOption('radios', 'c1')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 593px; position: absolute"
      >Dos Sílabas
      <input type="checkbox"
        ref="c2" 
        v-on:change="saveOption('radios', 'c2')" 
        :onload="loadOption('radios', 'c2')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 421px; top: 593px; position: absolute"
      >Tres Sílabas
      <input type="checkbox"
        ref="c3" 
        v-on:change="saveOption('radios', 'c3')" 
        :onload="loadOption('radios', 'c3')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 593px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="c4" 
        v-on:change="saveOption('radios', 'c4')" 
        :onload="loadOption('radios', 'c4')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 593px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox"
        ref="c5" 
        v-on:change="saveOption('radios', 'c5')" 
        :onload="loadOption('radios', 'c5')"
        />
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 593px; position: absolute"
      >Seis Sílabas
      <input type="checkbox"
        ref="c6" 
        v-on:change="saveOption('radios', 'c6')" 
        :onload="loadOption('radios', 'c6')"
        />
      <span class="checkmark-a"></span>
    </label>

  <div style="width: 230px; height: 200px; top: 530px; left: 730px; position: absolute;">
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/pinnedTag.svg"
    />
  </div>
    
  </div>
</template>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>